<template>
    <div id="designEdit">
        <div class="m-0">
            <div class="d-flex justify-content-center py-1 my-1" v-if="result">
                <p v-if="result.message">{{ result.message }}</p>
            </div>

            <div id="email-customer-template">
                <div class="btn-base-client mt-4 mb-4 pb-2 d-flex justify-content-between">
                    <span>
                        <span class="btn btn-primary fs-xs fw-medium rounded-8 h-40 mt-1" @click="toogleShowTemplates">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M15 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V7L15 2Z"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M14 2V6C14 6.53043 14.2107 7.03914 14.5858 7.41421C14.9609 7.78929 15.4696 8 16 8H20"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                            {{ $t('marketing.campaigns.saved_models') }}
                        </span>
                        <div class="tooltip pt-3" v-if="showTemplates">
                            <div style="display: flex; justify-content: flex-end">
                                <span class="mb-2 p-1" @click="showTemplates = false">
                                    <i class="fa fa-times"></i>
                                </span>
                            </div>
                            <div class="checkbox-group">
                                <label v-for="(item, index) in savedEmailTemplates" :key="index" class="checkbox-label">
                                    <input
                                        type="radio"
                                        :value="item.filename"
                                        class="checkbox-input"
                                        v-model="selectedOption"
                                        @change="handleOptionChange(item?.content)"
                                    />
                                    {{ item.filename }}
                                </label>
                            </div>
                        </div>
                    </span>

                    <div style="float: inline-end">
                        <button class="btn btn-primary fs-xs fw-medium rounded-8 h-40 mt-1" v-on:click="saveDesign">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16L21 8V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21Z"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M17 21V13H7V21"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M7 3V8H15"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                            {{ $t('marketing.campaigns.save_model') }}
                        </button>
                        <button class="btn btn-primary fs-xs fw-medium rounded-8 h-40 mt-1" v-on:click="exportHtmlAndOpenModal">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M15 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V7L15 2Z"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M14 2V6C14 6.53043 14.2107 7.03914 14.5858 7.41421C14.9609 7.78929 15.4696 8 16 8H20"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M12 12V18"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M15 15L12 12L9 15"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>

                            <!-- Font Awesome file export icon -->
                            {{ $t('common.export') }}
                        </button>

                        <div class="tooltip pt-3" v-if="showTooltipAddDesign">
                            <input
                                class="form-control mb-3 w-100"
                                type="text"
                                :placeholder="$t('marketing.campaigns.indicate_filename')"
                                v-model="designFilename"
                                maxlength="15"
                                :style="{ borderColor: designFilename.length >= 15 ? 'red' : '' }"
                            />
                            <button
                                class="btn fs-sm btn-dark py-2 rounded-8 fw-medium ms-2 mt-4 btn-validate"
                                :disabled="isLoadingSendTemplate"
                                @click="sendDesign()"
                            >
                                <span v-if="!isLoadingSendTemplate">{{ $t('common.validate') }}</span>
                                <span v-else>{{ $t('common.loading') }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="block-content block-content-full px-5 py-5 mb-0">
                <EmailEditor
                    ref="emailEditor"
                    v-on:load="editorLoaded"
                    :min-height="minHeight"
                    :projectId="projectId"
                    :locale="locale"
                />

                <div class="btns mt-3">
                    <button
                        class="btn btn-primary btn-plr-15 fs-xs fw-medium rounded-8 h-40 mt-1"
                        :disabled="isLoadingConfirmBtn"
                        @click="campaigneEmailConfirm"
                    >
                        <span v-if="isLoadingConfirmBtn">
                            <i class="fa fa-spinner fa-spin fa-fw"></i> {{ $t('common.loading') }}
                            <span class="sr-only">{{ $t('common.loading') }}</span>
                        </span>
                        <span v-else>
                            <i class="fas fa-check" :title="$t('common.validate')"></i> {{ $t('common.confirm') }}
                        </span>
                    </button>
                </div>
            </div>
        </div>

        <modal
            name="fullscreen-modal"
            width="80%"
            height="90%"
            :adaptive="false"
            :scrollable="true"
            :draggable="false"
            :click-to-close="true"
        >
            <button class="btn-close btn-exit" @click="$modal.hide('fullscreen-modal')"></button>
            <div class="email-content">
                <div v-html="htmlContent"></div>
            </div>
        </modal>
    </div>
</template>

<script>
import { EmailEditor } from 'vue-email-editor'
import sample from './data/design1.json'
import ApiManager from '../Customer/Api/ApiManagerBoCutomer.js'
import ApiManagerMarketing from './Api/ApiManagerMarketing.js'

export default {
    name: 'EmailTemplate',
    props: ['url', 'url_btn_campaigne_email_create'],
    components: {
        EmailEditor,
    },
    data: () => ({
        htmlContent: '',
        object: '',
        minHeight: '700px',
        locale: 'fr',
        projectId: 1,
        tools: {
            // disable image tool
            image: {
                enabled: true,
            },
        },
        options: {},
        appearance: {
            theme: 'light',
            panels: {
                tools: {
                    dock: 'right',
                },
            },
        },
        optionsString: {
            body: {
                rows: [],
            },
        },

        mode: 'light',
        isLoadingSendingEmails: false,
        result: '',

        showTemplates: false,
        savedEmailTemplates: [],
        selectedOption: '',

        isLoadingSendTemplate: false,
        showTooltipAddDesign: false,
        isLoadingConfirmBtn: false,
        designFilename: '',
    }),
    methods: {
        sleep(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms))
        },

        changeStyle() {
            if (this.mode === 'dark') {
                this.mode = 'light'
            } else {
                this.mode = 'dark'
            }
        },

        handleDrag({ target, left, top }) {
            console.log('onDrag left, top', left, top)
            target.style.left = `${left}px`
            target.style.top = `${top}px`
        },

        handleResize({ target, width, height, delta }) {
            console.log('onResize', width, height)
            delta[0] && (target.style.width = `${width}px`)
            delta[1] && (target.style.height = `${height}px`)
        },

        handleScale({ target, transform, scale }) {
            console.log('onScale scale', scale)
            target.style.transform = transform
        },

        handleRotate({ target, dist, transform }) {
            console.log('onRotate', dist)
            target.style.transform = transform
        },

        handleWarp({ target, transform }) {
            console.log('onWarp', target)
            target.style.transform = transform
        },
        editorLoaded() {
            this.$refs.emailEditor.editor.loadDesign(sample)
        },

        saveDesign() {
            this.designFilename = ''
            this.showTooltipAddDesign = true
        },

        sendDesign() {
            this.$refs.emailEditor.editor.saveDesign((design) => {
                this.saveEmailDesign({
                    content: design,
                    filename: this.designFilename,
                })
            })
        },

        exportHtml() {
            this.$refs.emailEditor.editor.exportHtml((data) => {
                this.htmlContent = data.html ? data.html.replace(/\n/g, '') : data
            })
        },

        exportHtmlAndOpenModal() {
            this.$modal.show('fullscreen-modal')
            this.exportHtml()
        },

        toogleShowTemplates() {
            this.showTemplates = !this.showTemplates
        },

        handleOptionChange(content) {
            console.log('Selected option:', content)
            this.$refs.emailEditor.editor.loadDesign(content)
        },

        async sendEmails() {
            const payload = {
                object: this.object,
                description: this.htmlContent,
                insert_id: '-1',
            }

            try {
                this.isLoadingSendingEmails = true
                this.result = await ApiManager.sendEmails(payload)
            } catch (error) {
                this.$toast.error(error.response.data.message)
                //
            } finally {
                this.isLoadingSendingEmails = false
                this.$modal.hide('fullscreen-modal')
            }
        },

        async saveEmailDesign(data) {
            this.isLoadingSendTemplate = true
            try {
                this.result = await ApiManager.saveEmailDesign(data)
            } catch (error) {
                this.$toast.error(error.response.data.message)
                //
            } finally {
                this.isLoadingSendTemplate = false
                this.showTooltipAddDesign = false
                this.fetchSavedEmailsTemplates()
            }
        },

        async fetchSavedEmailsTemplates() {
            try {
                this.savedEmailTemplates = await ApiManager.fetchSavedEmailsTemplates()
            } catch (error) {
                this.$toast.error(error.response.data.message)
                //
            } finally {
            }
        },

        async campaigneEmailConfirm() {
            const urlParams = new URLSearchParams(window.location.search)

            this.isLoadingConfirmBtn = true

            await this.exportHtml()
            await this.sleep(700)

            const payload = {
                uuid: urlParams.get('campaigne_email_uuid') || '',
                model: urlParams.get('model') || '',
                content: this.htmlContent,
            }

            try {
                const result = await ApiManagerMarketing.campaigneEmailsConfirm(payload)

                if (result.success) {
                    this.$toast.success(result?.message ?? this.$t('marketing.messages.operation_success'))
                    this.sleep(3500)
                    this.goToCreateCampaign(payload?.uuid)
                } else {
                    this.$toast.error(result?.message ?? this.$t('common.error_occurred'))
                }
            } catch (error) {
                this.$toast.error(error.response.data.message)
            } finally {
                this.isLoadingConfirmBtn = false
            }
        },

        goToCreateCampaign(uuid = '') {
            window.location.href =
                uuid === ''
                    ? this.url_btn_campaigne_email_create
                    : `${this.url_btn_campaigne_email_create}?campaigne_email_uuid=${uuid}`
        },
    },
    mounted() {
        this.fetchSavedEmailsTemplates()
    },
}
</script>

<style scoped>
#app,
#designEdit {
    height: 100%;
}

#designEdit .container {
    display: flex;
    flex-direction: column;
    position: relative;
    height: 100%;
}

iframe,
#editor-1 iframe,
#editor iframe,
.unlayer-editor iframe {
    min-height: 700px !important;
}

#editor .blockbuilder-branding,
#editor-1 .blockbuilder-branding,
#editor .blockbuilder-branding,
.blockbuilder-branding,
.jswdLm .blockbuilder-branding,
iframe .blockbuilder-branding,
.unlayer-editor .blockbuilder-branding {
    display: none !important;
}

.email-content {
    height: calc(100% - 120px);
    overflow-y: auto;
    /*padding-top: 40px;*/
}

.btn-exit {
    position: absolute;
    top: 10px;
    right: 10px;
}

.btn-send {
    position: absolute;
    bottom: 41px;
    right: 29px;
}

.vm--modal {
    background-color: #ebe5dd;
}

.checkbox-group {
    margin-top: 5px;
}

.checkbox-label {
    display: block;
    margin-bottom: 3px;
}

.checkbox-input {
    margin-right: 5px;
    display: inline-block;
}

.tooltip {
    position: absolute;
    background-color: #fff;
    color: #0238;
    border: solid 1px #e2e8f0;
    padding: 20px;
    border-radius: 13px;
    z-index: 999;
    max-width: 500px;
    min-width: 200px;
    margin-top: 5px;
    box-shadow: 0px 0px 7px 2px #e2e8f0;
    font-size: 16px;
    max-height: 300px;
    overflow: auto;
}
.btn-close-tooltip {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    background-color: #f8fafc !important;
    margin: 0 !important;
    height: 38px;
    width: 41px;
    margin-bottom: 10px !important;
}
</style>
